import { useTimeZone } from '../../../hooks'
import { createDay } from '../../../utils/date'
import { DateTimeInput } from '../DateTimeInput'

import {
  DATE_INPUT_FORMAT_HINT,
  DATE_INPUT_FORMAT_MAX_LENGTH,
} from './DateInput.constants'
import { formatDateInputValue, parseDateInputValue } from './DateInput.utils'

import * as styles from './DateInput.module.css'

function DateInput({
  Component = DateTimeInput,
  createDate = createDay,
  maxValue,
  minValue,
  wrapperClassName = styles.DateInputWrap,
  ...componentProps
}) {
  const timeZone = useTimeZone()

  function parse(string) {
    return parseDateInputValue(string, {
      createDate,
      maxValue,
      minValue,
      timeZone,
    })
  }

  return (
    <Component
      {...componentProps}
      format={formatDateInputValue}
      formatHint={DATE_INPUT_FORMAT_HINT}
      maxLength={DATE_INPUT_FORMAT_MAX_LENGTH}
      parse={parse}
      wrapperClassName={wrapperClassName}
    />
  )
}

export default DateInput
